import { start } from "./app";

start(document.getElementById("app")!);
